module.exports = __webpack_public_path__ + "img/vpn-blog-1.a17daf45.png";